module.exports = __webpack_public_path__ + "static/img/infoheadertext.6ec68ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/txinfo/infoheadertext.png
// module id = 7aAS
// module chunks = 1